<template>

  <transition name="fade">

    <div v-if="!small" class="d-flex justify-content-center align-items-center p-5">


      <div class="loader">
        <div class="ball-scale-multiple">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

    </div>

    <div v-else>

      <div class="loader">
        <div class="ball-clip-rotate-multiple">
          <div style="width: 15px; height: 15px; left: 0px; top:0px; border-color: var(--template-color-primary)" ></div>
          <div
              style="width: 15px; height: 15px; left: 0px; top: 0px; border-color: var(--template-color-primary)"></div>
        </div>
      </div>

    </div>


  </transition>
</template>

<script>
export default {
  name: "t-loading",
  data() {
    return {

    }
  },
  props: {
    show: Boolean,
    small: Boolean,
  },
  mounted() {



  },
}
</script>